import { getDateFormat } from 'helpers/dates'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { subWeeks } from 'date-fns'
import { formatMessage } from 'lib/intl'
import DateRangeInput, { THEME_MYJOB } from 'components/common/Form/DateRange'
import { setActiveFilter } from 'reducers/myJobsDataViewer/action'

class FilterDateRange extends Component {
  onChange = ({ startDate, endDate }) => {
    const { setActiveFilter } = this.props
    const activeDateRange = {
      start: moment(startDate),
      end: moment(endDate),
    }

    setActiveFilter({ activeDateRange })
  }

  render() {
    const {
      licensee: { usaDateFormat },
    } = this.props
    const dateFormat = getDateFormat(usaDateFormat)

    return (
      <DateRangeInput
        styleTheme={THEME_MYJOB}
        label={formatMessage('date_range')}
        dateDisplayFormat={dateFormat}
        range={[
          {
            key: 'selection',
            startDate: subWeeks(new Date(), 1),
            endDate: new Date(),
          },
        ]}
        inputProps={{
          disabled: false,
        }}
        dateRangeProps={{
          showMonthAndYearPickers: true,
          months: 1,
        }}
        onChange={this.onChange}
      />
    )
  }
}

export default connect(
  state => ({
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
  { setActiveFilter },
)(FilterDateRange)
